import getLocalString from "constants/Localization";
import { useDeleteProposalMaterialNoPlantMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useDeleteProposalMaterialNoPlant() {
  const [mutation, { loading, data, error }] = useDeleteProposalMaterialNoPlantMutation({
    refetchQueries: ["customGetProposal"],
  });
  const [deleteProposalMaterialNoPlant, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "deleteProposalMaterialNoPlant",
    },
    {
      failureMessage: getLocalString("proposals.delete-proposal-material-no-plant-failure"),
      successMessage: getLocalString("proposals.delete-proposal-material-no-plant-success"),
    }
  );
  return [deleteProposalMaterialNoPlant, context] as const;
}
